// Librairies
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TranslateModule } from '@ngx-translate/core';

// An optional setting of the widget editor: a card like the X Axis / Y Axis ones, switched on in its header.
// Unavailable: greyed out with the reason; on: its body (the projected content) unfolds.
// Not switchable: no switch, the body is always open (settings of the widget type itself).
@Component({
  selector: 'app-widget-option-card',
  standalone: true,
  imports: [
    MatIconModule,
    MatSlideToggleModule,
    TranslateModule
  ],
  templateUrl: './widget-option-card.component.html',
  styleUrl: './widget-option-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  // "title" is an input: not the native tooltip of the whole card too (an untranslated key over every field).
  host: { '[attr.title]': 'null' }
})

export class WidgetOptionCardComponent {
  // Variables
  @Input({ required: true }) title!: string;          // i18n key
  @Input() icon: string = '';
  @Input() toggleLabel: string = '';                 // i18n key, next to the switch
  @Input() enabled: boolean = false;
  @Input() switchable: boolean = true;
  @Input() disabled: boolean = false;
  @Input() reason: string | null = null;            // i18n key, shown when disabled
  @Output() toggled: EventEmitter<boolean> = new EventEmitter();
}
